import { useEffect, useRef } from 'react';
import { useReportStore } from '../../store';
import { useTransactionDateBounds } from '../../hooks';
import { DateRangePicker } from './DateRangePicker';
import { CategoryMultiSelect } from './CategoryMultiSelect';

export function ReportFilters() {
  const {
    dateRange,
    setDateRange,
    selectedCategoryIds,
    setCategoryIds,
    clearCategorySelection,
    resetFilters,
  } = useReportStore();

  const { minDate, maxDate } = useTransactionDateBounds();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!hasInitialized.current && minDate && maxDate) {
      setDateRange({ start: minDate, end: maxDate });
      hasInitialized.current = true;
    }
  }, [minDate, maxDate, setDateRange]);

  const handleResetFilters = () => {
    if (minDate && maxDate) {
      setDateRange({ start: minDate, end: maxDate });
    } else {
      resetFilters();
    }
    clearCategorySelection();
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 mb-6">
      <div className="flex flex-col gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:items-end gap-4">
          <DateRangePicker
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
            minDate={minDate}
            maxDate={maxDate}
          />
          <CategoryMultiSelect
            selectedIds={selectedCategoryIds}
            onSelect={setCategoryIds}
            onClear={clearCategorySelection}
          />
          <button
            type="button"
            onClick={handleResetFilters}
            className="sm:col-span-2 lg:col-span-1 px-4 py-2 text-sm text-mid-gray hover:text-near-black transition-colors min-h-[44px] border border-transparent hover:border-gray-200 rounded lg:self-end"
          >
            Restablecer filtros
          </button>
        </div>
      </div>
    </div>
  );
}
